import { Component, forwardRef, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-d-checkbox',
  templateUrl: './d-checkbox.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DCheckboxComponent),
      multi: true
    }
  ]
})
export class DCheckboxComponent extends DynamicComponentBase {
  static KEY = 'd-checkbox';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: '1',
          label: '选项1'
        },
        {
          value: '2',
          label: '选项2'
        },
        {
          value: '3',
          label: '选项3'
        }
      ];
    }

    if (Array.isArray(config.dataSource) && config.value) {
      config.dataSource.map(data => {
        let valueArr = config.value.split(',');
        if (valueArr.includes(data.value)) {
          data.checked = true;
        }
      });
    }
  }
}
